/*  */
import AvatarActions from 'actions/AvatarActions';
import AvatarStore from 'stores/AvatarStore';
import PropTypes from 'prop-types';
import * as React from 'react';
import Dialog from 'components/Dialog';
import List from 'components/List';
import ListItem from 'components/ListItem';
import BoxBody from 'components/BoxBody';
import Image from 'components/Image';
import Glyph from 'components/Glyph';
import cx from 'classnames';
import './styles/GroupAvatarPicker.scss';

// @ts-expect-error ts-migrate(2304) FIXME: Cannot find name '$FlowFixMeProps'.
class GroupAvatarPicker extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    onSelect: PropTypes.func,
    selectedAvatar: PropTypes.number,
  };

  static prefetch = [
    function () {
      if (AvatarStore.areGroupAvatarsLoaded()) {
        return Promise.resolve();
      } else {
        return AvatarActions.loadGroupAvatars();
      }
    },
  ];

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'avatar' implicitly has an 'any' type.
  handleSelection = (avatar) => {
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
    if (this.props.onSelect) {
      this.props.onSelect(avatar);
    }
  };

  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'avatar' implicitly has an 'any' type.
  renderAvatar = (avatar, index) => {
    const selected = this.props.selectedAvatar === avatar.id;

    const selectedGlyph = selected ? (
      <div className="GroupAvatarPicker-avatar-selectedCheck">
        <Glyph name="check" size="medium" />
      </div>
    ) : null;

    return (
      <ListItem
        key={index}
        className={cx('GroupAvatarPicker-avatar', { selected })}
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: (Element | null)[]; key: any; cl... Remove this comment to see the full error message
        onClick={() => this.handleSelection(avatar)}
      >
        <Image className="GroupAvatarPicker-avatar-image" src={avatar.getUrl()} />
        {selectedGlyph}
      </ListItem>
    );
  };

  render() {
    return (
      <Dialog eventScreenName="GroupAvatarPicker" {...this.props} title="Select a class icon">
        <BoxBody divided>
          <List>{AvatarStore.getGroupAvatars().map(this.renderAvatar)}</List>
        </BoxBody>
      </Dialog>
    );
  }
}

export default GroupAvatarPicker;
